import React, { useState, useEffect } from 'react';
import { Download, X, Share } from 'lucide-react';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // No mostrar si ya está instalada como PWA
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return;
    // No mostrar si ya fue descartado
    if (localStorage.getItem('pwa-install-dismissed')) return;

    const ios = /iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase());
    setIsIOS(ios);

    if (ios) {
      // En iOS mostrar banner con instrucciones después de 3s
      const timer = setTimeout(() => setShowBanner(true), 3000);
      return () => clearTimeout(timer);
    }

    // Android/Chrome: capturar evento beforeinstallprompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowBanner(false);
    setDeferredPrompt(null);
  };

  const dismiss = () => {
    setShowBanner(false);
    localStorage.setItem('pwa-install-dismissed', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 animate-slide-up">
      <div className="bg-[#1c1c1a] border border-gray-700 rounded-2xl p-4 shadow-2xl max-w-md mx-auto">
        <button onClick={dismiss} className="absolute top-3 right-3 text-gray-400 hover:text-white">
          <X className="w-5 h-5" />
        </button>

        {isIOS ? (
          <div className="pr-6">
            <p className="text-white font-semibold text-sm mb-2">Instalá Car Tracker</p>
            <p className="text-gray-400 text-xs leading-relaxed">
              Tocá <Share className="w-3.5 h-3.5 inline text-blue-400 -mt-0.5" /> en la barra de Safari y luego <span className="text-white font-medium">"Agregar a inicio"</span>
            </p>
          </div>
        ) : (
          <div className="flex items-center gap-3 pr-6">
            <div className="p-2 bg-[#7b8fa8]/10 rounded-xl">
              <Download className="w-5 h-5 text-[#7b8fa8]" />
            </div>
            <div className="flex-1">
              <p className="text-white font-semibold text-sm">Instalá Car Tracker</p>
              <p className="text-gray-400 text-xs">Acceso rápido desde tu pantalla de inicio</p>
            </div>
            <button
              onClick={handleInstall}
              className="px-4 py-2 bg-[#2f6b4f] text-white text-sm font-medium rounded-xl hover:bg-indigo-600 transition-colors"
            >
              Instalar
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;
